import {default as defaultPluralize} from 'pluralize';

export function pluralize(word: string, count?: number, inclusive?: boolean) {
  if (typeof count === 'string') {
    count = parseFloat(count);
  }
  if (typeof word === 'string') {
    return defaultPluralize(word, count, inclusive);
  }
  return '';
}
